var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-select',{attrs:{"items":_vm.opChoices,"label":"Op","outlined":"","value":_vm.value.op},on:{"input":_vm.updateOp}}),_c(_vm.componentToRender,{tag:"component",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }